import { locations } from 'services/routes/locations';

const getSongDetailsURL = (
  songId: string,
  songName: string,
  isAIGenerated = true
): string => {
  const { location } = window;
  const homepage = `${location.origin}${process.env.PUBLIC_URL ?? ''}`;
  const songDetailsPathname = locations.general.songDetails.pathname(
    songId,
    songName,
    isAIGenerated
  );

  return `${homepage}${songDetailsPathname}`;
};

export default getSongDetailsURL;
